import { createSlice } from '@reduxjs/toolkit'
export const userSlice = createSlice({
    name: 'user',
    initialState: {
        value: 0, userVO: null, labelVOList: null, reduxBriefVO: null, customOutlineTitle: [],
        reduxAnnotationVO: null, removedLabelVOList: null, reduxAnnotationVOList: [], labelSettingsVOList: null, sessionAuthenticationToken: null,
    },
    reducers: {
        increment: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value += 1;
        },
        decrement: (state) => { state.value -= 1; },
        setUserDetails: (state, action) => {
            state.userVO = action.payload;
        },
        setSessionAuthenticationToken: (state, action) => {
            state.sessionAuthenticationToken = action.payload;
        },
        setLabelVOList: (state, action) => {
            state.labelVOList = action.payload;
        },
        setRemovedLabelVOList: (state, action) => {
            state.removedLabelVOList = action.payload;
        },
        setLabelSettingsVOList: (state, action) => {
            state.labelSettingsVOList = action.payload;
        },
        setCustomOutlineTitle: (state, action) => {
            state.customOutlineTitle = action.payload;
        },
        setRemovedColorsVOList: (state, action) => {
            state.removedColorsVOList = action.payload;
        },
        setUserSettingVO: (state, action) => {
            state.userSettingVO = action.payload;
        },
        setReduxAnnotationVOList: (state, action) => {
            state.reduxAnnotationVOList = action.payload;
        },
        setReduxAnnotationVO: (state, action) => {
            state.reduxAnnotationVO = action.payload;
        },
        setReduxBriefVO: (state, action) => {
            state.reduxBriefVO = action.payload;
        },
    },
})
// Action creators are generated for each case reducer function
export const { setUserDetails, increment, decrement, setSessionAuthenticationToken, setLabelVOList, setRemovedLabelVOList,
    setLabelSettingsVOList, setCustomOutlineTitle, setRemovedColorsVOList, setUserSettingVO, setReduxAnnotationVOList, setReduxAnnotationVO,
    setReduxBriefVO } = userSlice.actions;
export default userSlice.reducer;